// Import helper functions for creating a location search adapter and getting a location object ID
import { createLocationSearchAdapter, getLocationObjectId } from '../common/locationSearchClient';

export default {
    // Returns a singleton instance of the location search adapter.
    // If it doesn't exist yet, it creates one using the provided searchOptions, which defaults to Algolia.
    getLocationSearchAdapter() {
        if (!this.locationSearchAdapter) {
            this.locationSearchAdapter = createLocationSearchAdapter(this.searchOptions);
        }

        return this.locationSearchAdapter;
    },

    // Returns a function suitable for use as a data source in autocomplete components.
    // The returned function takes a query and a callback, performs a search, and calls the callback with the results.
    locationSearchSource() {
        return (query, callback) => {
            this.getLocationSearchAdapter()
                .search(query, {
                    hitsPerPage: this.hits,
                    filters: this.locationFilters,
                })
                .then((hits) => callback(hits)) // Pass search results to the callback
                .catch(() => callback([]));
        };
    },

    // Loads the initial location object by its ID and updates the autocomplete input.
    // Emits an 'input' event with the loaded location content.
    loadInitialLocation(locationId) {
        return this.getLocationSearchAdapter()
            .getObject(getLocationObjectId(locationId, this.searchOptions))
            .then((content) => {
                if (!content) {
                    return;
                }

                // Set the autocomplete input value to the location name
                this.autocomplete.autocomplete.setVal(content.name);

                // Emit the loaded location object as an input event
                this.$emit('input', content);
            })
            .catch(() => null);
    },
};
